export const HUB_NEWSROOM = {
  HUB_NEWSROOM_TITLE: 'HUB_NEWSROOM_TITLE',
};
